import React, { useEffect, useRef, useState } from 'react';
// import { MdArrowBackIos } from 'react-icons/md';
import { GoTrash } from 'react-icons/go';
// import HeaderSection from './properties_partials/HeaderSection';
import KeywordSection from './properties_partials/keywordSection';
import SectionTabs from './properties_partials/SectionTabs';
import DescriptionSection from './properties_partials/DescriptionSection';
import FilesSection from './properties_partials/FilesSection';
import DropdownArrow from '../../../media/icons/assets_light/outline-action-dropdown-active.svg';
import TaskStatusAndProgressNew from './properties_partials/TaskStatusAndProgressNew';
import StartEndDateTimeTaskNew from './properties_partials/StartEndDateTimeTaskNew';
import RolePanel from './properties_partials/RolePanel';
// import TimeTracking from './properties_partials/TimeTracking';
// import CostTracking from './properties_partials/CostTracking';
import TrackingMainContainer from './properties_partials/TaskTraking/TrackingMainContainer';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { set_active_discussion, set_active_task } from '../../../redux/taskSlice';
import { useTaskContext } from '../../../context/TaskContext';
import { useQuery } from '@apollo/client';
import { GET_SINGLE_TASK } from '../../../apollo/Queries';
import { getONLYUSERSDATA, isValidUUID, modifyMyMsg } from '../../../Utils/Common';
import { useSelector } from 'react-redux';
import { set_active_conversation } from '../../../redux/messageSlice';
import toast from 'react-hot-toast';
import DiscussionSection from './properties_partials/DiscussionSection';
import FileDrawer from '../../connect/chat/FileDrawer';
import FileViewPopup from '../../connect/chat/FileViewPopup';
import TagsPopup from '../../connect/TagsPopup';
import Downloading from '../../connect/chat/Downloading';
import FileSharePopup from '../../connect/chat/FileSharePopup';
import ListOfUsers from '../../popup/ListOfUsers';
import DeleteMessage from '../../connect/chat/DeleteMessage';
import DeleteFile from '../../connect/chat/DeleteFile';
import { UploadProvider } from '../../../context/UploadContext';
import FileUpload from '../../connect/Fileupload/FileUpload';
import TaskDetailsWarning from '../TaskDetails/TaskDetailsWarning';
import TaskDuplicatePopup from '../TaskDetails/TaskDuplicatePopup';
import ProjectSelectDetailsPopup from '../TaskDetails/ProjectSelectDetailsPopup';
import { IoClose, IoCopyOutline } from 'react-icons/io5';
import NotificationIcon from '../../../media/icons/assets_light/outline-management-notification-active-white.svg';
import TaskDetailsNotificationsNew from './properties_partials/TaskDetailsNotificationsNew';
import ActionMenuIcon from "../../../media/icons/assets_light/outline-action-menu-2-active.svg";
import moment from 'moment';
import { TbFlag2, TbFlag2Filled } from 'react-icons/tb';
import TaskMenu from './properties_partials/TaskMenu';
import RoomSelectionPopup from '../CreateEidtTask/RoomSelectionPopup';
import DeleteTaskModal from '../CreateEidtTask/DeleteTaskModal';
import { LuCheck } from 'react-icons/lu';
import ProjectModal from './properties_partials/ProjectModal';
import RoomModal from './properties_partials/RoomModal';

// Helper function to decode HTML entities
const decodeHtmlEntities = (text) => {
    if (!text) return '';
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};

const TaskPropertiesHome = () => {
    const { slug, task_id } = useParams();
    const { set_tasks, user, delete_task, OnUpdateTask, selectedTask, setSelectedTask, isObserver, isAssignee } = useTaskContext();
    const dispatch = useDispatch()
    const { active_task } = useSelector(state => state.task);
    const { file_drawer } = useSelector(state => state.message);
    const [fileViewPopup, setFileViewPopup] = useState(false);
    const { allUsers, conversationMap, conversations, upload_popup, tag_popup, downloading_progress, linkShare_popup, userList } = useSelector(state => state.message);
    const conversationId = conversationMap?.[slug];
    const [loader, setLoader] = useState(true)

    const [roomSelectPopup, setRoomSelectPopup] = useState(false);
    const [projectSelectPopup, setProjectSelectPopup] = useState(false);
    const [editingTaskTitle, setEditingTaskTitle] = useState(false);
    const [editingTaskTitleText, setEditingTaskTitleText] = useState('');
    const [taskDescriptionPopup, setTaskDescriptionPopup] = useState(false);
    const [taskNotePopup, setTaskNotePopup] = useState(false);
    const [taskFilePopup, setTaskFilePopup] = useState(false);
    const [taskCheckListPopup, setTaskCheckListPopup] = useState(false);
    const [taskTrackCostPopup, setTaskTrackCostPopup] = useState(false);
    const [taskTrackHourPopup, setTaskTrackHourPopup] = useState(false);
    const [editProject, setEditProject] = useState(false);
    const [cost_id, set_cost_id] = useState('');
    const [duplicateTaskPopup, setDuplicateTaskPopup] = useState(false);
    const [taskDeleteWarning, setTaskDeleteWarning] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);

    const [activeTab, setActiveTab] = useState("description");
    const [mainSectionOpen, setMainSectionOpen] = useState(true);
    const [expandedSections, setExpandedSections] = useState(true);
    const [expandedSectionsTrack, setExpandedSectionsTrack] = useState(true);
    const [activeTrakingTab, setActiveTrakingTab] = useState("time");
    const [active, setActive] = useState('time');


    const [taskOptions, setTaskOptions] = useState(false);
    const [deletePopup, setDeletePopup] = useState(false);

    const navigate = useNavigate();
    const closeTask = () => {
        navigate(-1);
        dispatch(set_active_task(null));
    }

    useQuery(GET_SINGLE_TASK, {
        variables: task_id ? { _id: task_id } : undefined,
        fetchPolicy: 'no-cache',
        skip: !task_id,
        onCompleted: async (res) => {
            if (res?.task?.status) {
                const taskData = res.task.data?.[0] || {};
                if ((taskData?.created_by === user?.id || taskData?.assign_to?.includes(user.id) || taskData?.observers?.includes(user.id))) {
                    setSelectedTask({ ...taskData });
                    dispatch(set_active_task({ ...taskData }));
                    set_tasks(prev => prev.map(t => t._id === taskData?._id ? { ...t, view_update: t.view_update?.filter(uid => uid !== user.id) } : t))
                    if (taskData.discussion) {
                        const discussion = await modifyMyMsg(taskData.discussion);
                        dispatch(set_active_discussion(discussion));
                    }
                    if (!isValidUUID(conversationId)) {
                        const activeConversation = conversations.find((f) => f.conversation_id === taskData.conversation_id);
                        dispatch(set_active_conversation(activeConversation || null));
                    }
                    setLoader(false)
                } else {
                    toast.error('You don\'t have access to the task.')
                    // closePopUp()
                    dispatch(set_active_task(null))
                }
            }
        },
    });

    const [projectPopup, setProjectPopup] = useState(false);

    const handleProjectSelectForTask = (selectedProjectName) => {
        if (active_task) {
            // updateTaskProject(active_task?.id, selectedProjectName);
            setProjectPopup(false);
        }
    };

    const handleCloseProjectSelect = () => {
        setProjectPopup(false);
    };


    const inputRef = useRef(null);
    const optionsRef = useRef(null);

    // Close edit or menu on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (inputRef.current && !inputRef.current.value && !inputRef.current.contains(event.target)) {
                setEditingTaskTitle(false);
                setEditingTaskTitleText("");
            }
            if (optionsRef.current && !optionsRef.current.contains(event.target)) {
                setTaskOptions(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [editingTaskTitle, taskOptions]);

    const handleRoomSelectForTask = (selectedRoomName) => {
        if (active_task) {
            // updateTaskRoom(active_task?.id, selectedRoomName);
            setRoomSelectPopup(false);
        }
    };

    const setTaskDeletePopup = (value) => {
        console.log("Delete popup:", value);
        setDeletePopup(value);
    };

    // const handleCancelEdit = () => {
    //     setEditingTaskTitle(false);
    //     setEditingTaskTitleText("");
    // };

    // const handleSaveTitle = () => {
    //     if (editingTaskTitleText.trim() && active_task?.task_title !== editingTaskTitleText.trim()) {
    //         OnUpdateTask({ task_title: editingTaskTitleText, save_type: 'tasktitle' });
    //         // In real implementation, this would update the task
    //         setEditingTaskTitle(false);
    //     } else {
    //         toast.error('Task title cannot be empty or unchanged')
    //     }
    // };


    const [editing, setEditing] = useState(false);
    const [titleText, setTitleText] = useState(active_task?.task_title);


    const isDirty = titleText?.trim() !== active_task?.task_title;
    const isEmpty = titleText?.trim() === "";

    // const handleStartEdit = () => {
    //     setTitleText(active_task?.task_title);
    //     setEditing(true);
    // };

    const handleCancel = () => {
        setTitleText(active_task?.task_title);
        setEditing(false);
    };

    const handleSave = () => {
        if (!isEmpty && isDirty) {
            OnUpdateTask({ task_title: titleText, save_type: 'tasktitle' });
        } else {
            toast.error('Task title cannot be empty or unchanged')
        }
        setEditing(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSave();
        if (e.key === "Escape") handleCancel();
    };

    return (
        <div className='task w-full h-full fixed z-[16] bg-white top-0 properties animate__animated animate__zoomIn animation_duration'>
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0b1f47] to-[#06122a] px-4 pt-5 pb-6">
                <div className="flex items-center mb-3">
                    <button onClick={closeTask} className="flex items-center gap-1.5 text-white hover:text-white transition-colors group">
                        <svg className="w-5 h-5 transition-transform group-hover:-translate-x-0.5" fill="none" viewBox="0 0 24 24">
                            <path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="text-sm font-semibold">Back</span>
                    </button>
                </div>
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <div className="rounded-full bg-white/10 text-white border border-white/20 px-2.5 py-1">
                            <span className="text-xs text-opacity-50 font-medium">{active_task?.project_title}</span>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <button className="w-8 h-8 bg rounded-full flex items-center justify-center bg-white">
                            <div
                                onClick={() => setTaskOptions(!taskOptions)}
                                className="w-[24px] h-[24px] dark:bg-white bg-[#636E82]
                                                     cursor-pointer transition-colors text-md"
                                style={{
                                    WebkitMaskImage: `url(${ActionMenuIcon})`,
                                    WebkitMaskPosition: "center",
                                    WebkitMaskRepeat: "no-repeat",
                                    WebkitMaskSize: "contain",
                                    maskImage: `url(${ActionMenuIcon})`,
                                    maskRepeat: "no-repeat",
                                    maskPosition: "center",
                                    maskSize: "contain",
                                }}
                            />
                        </button>
                        <button className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                            {active_task?.flag?.includes(user?.id) ?
                                <TbFlag2Filled
                                    onClick={() => OnUpdateTask({ flag: active_task?.flag?.indexOf(user.id) > -1 ? [...active_task?.flag?.filter(f => f !== user.id)] : [...active_task?.flag, user.id] })}
                                    className="text-red-600 text-lg cursor-pointer"
                                />
                                :
                                <TbFlag2
                                    onClick={() => OnUpdateTask({ flag: active_task?.flag?.indexOf(user.id) > -1 ? [...active_task?.flag?.filter(f => f !== user.id)] : [...active_task?.flag, user.id] })}
                                    className="text-gray-500 dark:text-gray-400 text-lg cursor-pointer"
                                />
                            }
                        </button>
                        {user?.id === active_task?.created_by &&
                            <button className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm">
                                <GoTrash className='text-md cursor-pointer text-red-500' onClick={() => setTaskDeleteWarning(true)} />
                            </button>
                        }
                    </div>
                </div>

                {editing ? (
                    // <div className='flex gap-2 items-center w-full'>
                    //     <input
                    //         ref={inputRef}
                    //         className='border-b w-[80%] rounded pl-1 pr-1 py-0.5 break-all border border-teal-600 text-teal-600 text-sm outline-none min-w-[80px]'
                    //         value={editingTaskTitleText}
                    //         onChange={(e) => setEditingTaskTitleText(e.target.value)}
                    //         autoFocus
                    //     />
                    //     <div className='flex gap-2'>
                    //         <IoClose className="text-lg text-text-body cursor-pointer" onClick={handleCancelEdit} />
                    //         <LuCheck className={`text-base cursor-pointer ${active_task?.task_title === editingTaskTitleText?.trim() ? 'opacity-50 pointer-events-none text-text-body' : 'text-green-500'}`} onClick={handleSaveTitle} />
                    //     </div>
                    // </div>

                    <div className="title-edit-enter mb-3">
                        {/* Label */}
                        <p className="text-xs text-white font-medium mb-1.5 uppercase tracking-wide">Editing title</p>

                        {/* Input row */}
                        <div className={`flex items-center gap-2 bg-white/10 border rounded-lg px-3 py-2.5 transition-all ${isEmpty ? "border-red-400/60" : isDirty ? "border-white/60" : "border-white/20"}`}>
                            <input
                                autoFocus
                                ref={r => r && r.focus()}
                                value={titleText}
                                onChange={e => setTitleText(e.target.value)}
                                onKeyDown={handleKeyDown}
                                className="flex-1 bg-transparent text-white text-sm font-semibold placeholder-white/40 outline-none leading-snug"
                                placeholder="Enter task title…"
                                maxLength={120}
                            />
                            {/* Char count */}
                            <span className={`text-xs shrink-0 tabular-nums transition-colors ${titleText?.length > 100 ? "text-red-300" : "text-white"}`}>
                                {titleText?.length}/120
                            </span>
                        </div>

                        {/* Empty warning */}
                        {isEmpty && (
                            <p className="text-xs text-red-300 mt-1.5 flex items-center gap-1">
                                <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24">
                                    <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                                Title cannot be empty
                            </p>
                        )}

                        {/* Action buttons */}
                        <div className="flex gap-2 mt-3">
                            <button onClick={handleCancel}
                                className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-white hover:text-white text-xs font-semibold transition-all border border-white/10">
                                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
                                    <path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                                </svg>
                                Cancel
                            </button>
                            <button onClick={handleSave}
                                disabled={isEmpty || !isDirty}
                                className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold transition-all
                                        ${isEmpty || !isDirty ? "bg-white/10 text-white cursor-not-allowed border border-white/10"
                                        : "bg-white text-violet-700 hover:bg-white/90 shadow-lg shadow-violet-900/30"}`}>
                                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
                                    <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Save
                            </button>
                        </div>
                    </div>
                ) : (
                    <h1 className="text-white text-xl font-bold mb-1">{decodeHtmlEntities(active_task?.task_title)}</h1>
                )}
                <div className="flex items-center gap-1.5 ">
                    <span className="text-white text-opacity-50 text-xs">{`Created by ${getONLYUSERSDATA(allUsers, active_task?.created_by, 'name')}`}</span>
                </div>
                <div className="flex items-center gap-1.5 mb-4">
                    <svg className="w-3.5 h-3.5 text-white text-opacity-50" fill="none" viewBox="0 0 24 24">
                        <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <span className="text-white text-opacity-50 text-xs">{`Due ${moment(active_task?.created_at).utcOffset(6).format("dddd, MMMM Do, YYYY")}`}</span>
                </div>
                <KeywordSection type={"description"} />
            </div>

            {/* Status Bar */}
            {/* <div className="flex items-center gap-3 px-4 py-3 bg-slate-50 border-b border-slate-100">
                <span className="text-xs text-violet-600 font-medium bg-violet-50 px-2.5 py-0.5 rounded-full">Stage 01</span>
                <div className="w-px h-4 bg-slate-200"></div>
                <div className="flex items-center gap-1.5">
                    <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
                    <span className="text-xs text-slate-600 font-medium">In Progress</span>
                </div>
                <div className="ml-auto flex items-center gap-2.5">
                    <button className="text-slate-500">
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24">
                            <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                    <button className="text-slate-500">
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24">
                            <path d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                    <span className="text-xs text-slate-500 font-medium bg-slate-100 px-2 py-0.5 rounded-full">12</span>
                </div>
            </div> */}

            {/* <header className="filterFileHeader">
                <div className="allfilterFileHeader !ml-2" onClick={closeTask}>
                    <MdArrowBackIos className="allFileHeaderIcon text-2xl !mt-[0px]" />
                    <span className="allFileHeaderText">Task properties new</span>
                </div>
                <div className='flex items-center'>
                    <div className={`!flex items-center gap-2 px-4 py-2 text-[12px] cursor-pointer`} onClick={() => setShowNotifications(true)}>
                        <div
                            className="relative top-[0px] left-[0px] w-[24px] h-[24px] bg-white cursor-pointer"
                            style={{
                                WebkitMaskImage: `url(${NotificationIcon})`,
                                WebkitMaskRepeat: 'no-repeat',
                                WebkitMaskPosition: 'center',
                                WebkitMaskSize: 'contain',
                                maskImage: `url(${NotificationIcon})`,
                                maskRepeat: 'no-repeat',
                                maskPosition: 'center',
                                maskSize: 'contain',
                            }}
                        />
                    </div>
                    <IoCopyOutline className='text-xl cursor-pointer text-white mr-4' onClick={() => setDuplicateTaskPopup(true)} />
                    {user?.id === active_task?.created_by && <GoTrash className='text-xl cursor-pointer text-red-500 mr-4' onClick={() => setTaskDeleteWarning(true)} />}
                </div>
            </header> */}
            <div className='overflow-y-auto h-[calc(100%-238px)]'>
                {/* <div className='px-4 space-y-4 mb-4'>
                    <HeaderSection setShowNotifications={setShowNotifications} setProjectPopup={setProjectPopup} />
                    <KeywordSection type={"description"} />
                </div> */}
                <SectionTabs
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    mainSectionOpen={mainSectionOpen}
                    setMainSectionOpen={setMainSectionOpen}
                />
                {mainSectionOpen && (
                    <div className={`${activeTab === 'discussion' ? 'px-0' : 'px-4'}`}>
                        {activeTab === "description" ?
                            <DescriptionSection />
                            : activeTab === "files" ?
                                <FilesSection />
                                : <DiscussionSection />
                        }
                    </div>
                )}
                {activeTab === 'description' &&
                    <div className="py-2 px-4 flex items-center justify-between border-t border-b border-border-primary">
                        <h4 className="text-[12px] text-teal-600 dark:text-white">Task details</h4>
                        <div
                            onClick={() => setExpandedSections(!expandedSections)}
                            className={`relative top-[0px] right-[0px] w-[24px] h-[24px] bg-[#636E82] cursor-pointer transition-all duration-300 ${expandedSections ? 'rotate-180' : 'rotate-0'
                                }`}
                            style={{
                                WebkitMaskImage: `url(${DropdownArrow})`,
                                WebkitMaskRepeat: "no-repeat",
                                WebkitMaskPosition: "center",
                                WebkitMaskSize: "contain",
                                maskImage: `url(${DropdownArrow})`,
                                maskRepeat: "no-repeat",
                                maskPosition: "center",
                                maskSize: "contain",
                            }}
                        />
                    </div>
                }
                {(expandedSections && activeTab === 'description') &&
                    <div className='px-4'>
                        <TaskStatusAndProgressNew />
                        <StartEndDateTimeTaskNew />
                        <RolePanel />
                    </div>
                }
                {/* Tracking Tabs - Modern Mobile-First Design */}
                {activeTab === 'description' &&
                    <div className="bg-white dark:bg-surface-dark border-b border-t border-gray-200 dark:border-gray-800">
                        <div className="flex items-center justify-between px-4 py-3">
                            {/* Tab Buttons */}
                            <div className="flex items-center gap-1 bg-gray-100 dark:bg-surface-dark-2 p-1.5 rounded-2xl">
                                <button
                                    onClick={() => setActiveTrakingTab("time")}
                                    className={`px-3 py-1.5 rounded-xl text-xs font-medium transition-all duration-200 active:scale-95
                                    ${activeTrakingTab === "time"
                                            ? "bg-white dark:bg-surface-dark-3 text-teal-600 dark:text-teal-400 shadow-sm"
                                            : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                                        }`}
                                >
                                    <div className="flex items-center gap-1.5">
                                        <div className={`w-2 h-2 rounded-full ${activeTrakingTab === "time" ? "bg-teal-500" : "bg-gray-300 dark:bg-gray-600"}`} />
                                        Time Tracking
                                    </div>
                                </button>

                                <button
                                    onClick={() => setActiveTrakingTab("cost")}
                                    className={`px-3 py-1.5 rounded-xl text-xs font-medium transition-all duration-200 active:scale-95
                                    ${activeTrakingTab === "cost"
                                            ? "bg-white dark:bg-surface-dark-3 text-teal-600 dark:text-teal-400 shadow-sm"
                                            : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                                        }`}
                                >
                                    <div className="flex items-center gap-1.5">
                                        <div className={`w-2 h-2 rounded-full ${activeTrakingTab === "cost" ? "bg-teal-500" : "bg-gray-300 dark:bg-gray-600"}`} />
                                        Cost Tracking
                                    </div>
                                </button>
                            </div>

                            {/* Expand/Collapse Button */}
                            <button
                                onClick={() => setExpandedSectionsTrack(!expandedSectionsTrack)}
                                className={`w-10 h-10 rounded-full bbg-gray-100 dark:bbg-surface-dark-2 flex items-center justify-center active:bbg-gray-200 dark:active:bbg-surface-dark-3 transition-all duration-300 -mr-2 ${expandedSectionsTrack ? 'rotate-180' : ''}`}
                            >
                                <div
                                    className="w-6 h-6 bg-gray-500 dark:bg-gray-400"
                                    style={{
                                        WebkitMaskImage: `url(${DropdownArrow})`,
                                        WebkitMaskRepeat: "no-repeat",
                                        WebkitMaskPosition: "center",
                                        WebkitMaskSize: "contain",
                                        maskImage: `url(${DropdownArrow})`,
                                        maskRepeat: "no-repeat",
                                        maskPosition: "center",
                                        maskSize: "contain",
                                    }}
                                />
                            </button>
                        </div>
                    </div>
                }

                {activeTab === 'description' &&
                    <div className='px-4 pb-4'>
                        {expandedSectionsTrack && <TrackingMainContainer activeTrakingTab={activeTrakingTab} />}
                    </div>
                }

                {taskOptions && <TaskMenu
                    optionsRef={optionsRef}
                    setTaskOptions={setTaskOptions}
                    setProjectPopup={setProjectPopup}
                    setTaskDeletePopup={setTaskDeleteWarning}
                    setEditingTaskTitle={setEditing}
                    setEditingTaskTitleText={setTitleText}
                    setRoomSelectPopup={setRoomSelectPopup}
                    setShowNotifications={setShowNotifications}
                />}



            </div>

            <ProjectModal
                type="update"
                open={projectPopup}
                onClose={handleCloseProjectSelect}
                onSelectProject={handleProjectSelectForTask}
                projectEdit={editProject}
                setEditProject={setEditProject}
            />

            {/* {
                projectPopup && (
                    <ProjectSelectDetailsPopup
                        type="update"
                        onClose={handleCloseProjectSelect}
                        onSelectProject={handleProjectSelectForTask}
                        projectEdit={editProject}
                        setEditProject={setEditProject}
                    />
                )
            } */}

            {/* <RoomSelectionPopup
                type="update"
                isOpen={roomSelectPopup}
                onClose={() => setRoomSelectPopup(false)}
                onSelectRoom={handleRoomSelectForTask}
            /> */}

            <RoomModal
                type="update"
                open={roomSelectPopup}
                onClose={() => setRoomSelectPopup(false)}
                onSelectRoom={handleRoomSelectForTask}
            />

            <DeleteTaskModal isOpen={deletePopup} onClose={() => setTaskDeletePopup(false)} onConfirmDelete={() => { delete_task(selectedTask?._id); setTaskDeletePopup(false) }} />


            {(file_drawer && task_id) && <FileDrawer type='task' setFileViewPopup={setFileViewPopup} />}
            {fileViewPopup && <FileViewPopup setFileViewPopup={setFileViewPopup} />}
            {(tag_popup && task_id) && <TagsPopup type={'file'} />}
            {(Object.keys(downloading_progress).length !== 0 && task_id) && <Downloading />}
            {(linkShare_popup && task_id) && <FileSharePopup />}
            {(userList.state && task_id) && <ListOfUsers />}

            <DeleteMessage />
            <DeleteFile />
            {(upload_popup && task_id) && <UploadProvider><FileUpload task={active_task} cost_id={cost_id} from={taskTrackCostPopup ? '#TASK-COST' : '#TASK'} /></UploadProvider>}
            {/* <TaskDetailsWarning type="roomChange" isOpen={roomSelectWarning} onClose={() => setRoomSelectWarning(false)} onConfirm={""} /> */}
            <TaskDetailsWarning type="deleteTask" isOpen={taskDeleteWarning} onClose={() => setTaskDeleteWarning(false)} onConfirm={() => { delete_task(selectedTask?._id); setTaskDeleteWarning(false) }} />

            {duplicateTaskPopup && <TaskDuplicatePopup isOpen={duplicateTaskPopup} onClose={() => setDuplicateTaskPopup(false)} />}
            {showNotifications && <TaskDetailsNotificationsNew onClose={() => setShowNotifications(false)} />}
        </div>
    );
};

export default TaskPropertiesHome;